import { Button, Container } from 'components/atoms';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useParamId } from 'hooks/useParamId';
import { ChangeEvent, useEffect, useRef } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import {
  PiArrowsClockwise,
  PiFileVideo,
  PiTrash,
  PiVideoCameraSlash,
  PiWaveform,
} from 'react-icons/pi';
import { useGetVideoFile } from 'services/video/file';
import { IVideoMutationForm } from 'services/video/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { getFileExtension } from 'utils/global/file.utils';

const VideoFile = () => {
  const {
    values,
    status,
    initialValues,
    setFieldValue,
  }: IFormikContextType<IVideoMutationForm> =
    useFormikContext<IVideoMutationForm>();

  const inputRef = useRef<HTMLInputElement>(null);

  const id = useParamId();

  const videoFile = useGetVideoFile(
    id,
    !!initialValues.videoLink?.length && !!id.length
  );

  const videoRef = useRef<HTMLVideoElement>(null);

  const { t } = useTranslation();

  const onDeleteVideo = async () => {
    if (!values.originalVideoLink) {
      return setFieldValue('file', undefined);
    }

    if (values.originalVideoLink && !values.file) {
      setFieldValue('videoLink', '');
      setFieldValue('originalVideoLink', '');

      return;
    }
    if (values.file) {
      return setFieldValue('file', undefined);
    }
  };
  const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.currentTarget.files && event.currentTarget.files[0];

    if (file) {
      console.log(getFileExtension(file));

      const extension = getFileExtension(file);

      if (
        extension.toLowerCase() !== 'mp4' &&
        extension.toLowerCase() !== 'mov'
      )
        return toast.error(t('formik-error.invalid-file-extension'));

      setFieldValue('file', file);
      event.currentTarget.value = '';
    }
  };

  useEffect(() => {
    videoRef.current?.load();
  }, [values.file, values.videoLink]);

  // const [loaded, setLoaded] = useState(false);

  // useEffect(() => {
  //   console.log(values.file, videoFile.data, values.videoLink, loaded);
  //   videoRef.current?.load();
  //   values.file && console.log('values.file', URL.createObjectURL(values.file));
  //   videoFile.data && console.log('videoFile.data', videoFile.data);
  // }, [values.file, videoFile.data, values.videoLink, loaded]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     console.log('Aktualizacja co 2 sekundy z uwzględnieniem stanu!');
  //     videoRef.current?.load();
  //   }, 2000);

  //   return () => clearInterval(interval);
  // }, []);

  return (
    <div className='flex flex-col w-full gap-4'>
      <Container className='max-w-[900px] self-start'>
        <Container.Header
          title={
            <>
              <PiWaveform />
              {!values.file
                ? t('video.file.header')
                : t('video.file.addHeader')}
            </>
          }>
          {status?.displayMode ? null : (
            <div className='flex m-1 gap-1'>
              <Button
                isClear
                onlyIcon
                onClick={() => inputRef.current?.click()}>
                                <Button.Description description={t('button.addFile')} />

                                <Button.Icon icon={<PiFileVideo />} />
                <Button.Text text={t('button.addFile')} />
              </Button>
              <input
                ref={inputRef}
                className='hidden'
                type='file'
                onChange={onInputChange}
              />
              {(values.file || values.videoLink) && (
                <Button
                  onlyIcon
                  isClear
                  disabled={!values}
                  variant={BUTTON_VARIANT.remove}
                  onClick={onDeleteVideo}>
                                    <Button.Description description={t('button.remove')} />

                                    <Button.Icon icon={<PiTrash />} />
                </Button>
              )}
            </div>
          )}
        </Container.Header>

        <Container.Content className='flex flex-row justify-center items-center p-0 rounded-b-md overflow-hidden  w-[900px] h-[510px]'>
          {values.videoLink || values.file ? (
            <video
              ref={videoRef}
              controls
              controlsList='noplaybackrate nodownload'
              preload='metadata'
              // onLoadedMetadata={async e => {
              //   console.log('onLoadedMetadata', e.currentTarget);
              //   setLoaded(true);
              // }}

              width='900px'
              height='540px'>
              <source
                src={
                  values.file
                    ? URL.createObjectURL(values.file)
                    : values.videoLink ?? ''
                }
                // type='video/mov'
              />
            </video>
          ) : values.originalVideoLink ? (
            <div className='flex flex-col items-center justify-center w-full h-full gap-5'>
              <PiArrowsClockwise
                className='h-[150px] w-[150px] opacity-25 animate-spin'
                style={{ animationDuration: `3000ms` }}
              />
              <p className='opacity-50 text-lg'>
                {t('molecules.sections.converting')}
              </p>
            </div>
          ) : (
            <PiVideoCameraSlash className='h-[150px] w-[150px] opacity-25' />
          )}
        </Container.Content>
      </Container>
    </div>
  );
};

export default VideoFile;
